<template>
  <div class="crm-aside">
    <!-- 快速新增 -->
    <div v-if="authenticated">
      <div
        class="quick-add-but"
        @mouseleave="isQuickAddShow = false"
        v-show="!isShrink"
      >
        <div @mouseenter="isQuickAddShow = true">
          <el-button size="mini">
            <i class="el-icon-plus"></i>
            <span>快捷新增</span>
          </el-button>
        </div>
      </div>
      <div
        @mouseenter="isQuickAddShow = true"
        @mouseleave="isQuickAddShow = false"
        class="shrink-add-but"
        v-show="isShrink"
      >
        <el-button size="mini">
          <img src="@/images/icon/nav-add.png" alt="" />
        </el-button>
      </div>
      <div
        :class="{ 'shrink-ml': isShrink }"
        class="quick-add-dialog"
        v-show="isQuickAddShow"
        @mouseenter="isQuickAddShow = true"
        @mouseleave="isQuickAddShow = false"
      >
        <div>
          <ul>
            <li @click="handleAdd('clue')" v-if="quickAuth.quickAddClue && quickAuth.quickAddClue.toggleStatus">
              <img src="@/images/icon/nav-clue.png" />
              线索
            </li>
            <li @click="handleAdd('custom')" v-if="quickAuth.quickAddCustomer && quickAuth.quickAddCustomer.toggleStatus">
              <img src="@/images/icon/customer.png" />
              客户
            </li>
            <li @click="handleAdd('busi')" v-if="quickAuth.quickAddBusiness && quickAuth.quickAddBusiness.toggleStatus">
              <img src="@/images/icon/busi-oppotunity.png" />
              商机
            </li>
            <li @click="handleAdd('contract')" v-if="quickAuth.quickAddContract && quickAuth.quickAddContract.toggleStatus">
              <img src="@/images/icon/add-contact.png" />
              合同
            </li>
          </ul>
          <div class="arrow"></div>
        </div>
      </div>
    </div>

    <!-- 导航菜单 -->
    <crm-nav :isShrink="isShrink"></crm-nav>

    <!-- 收起展开 -->
    <div class="collapse">
      <span v-show="!isShrink"></span>
      <img
        v-if="!isShrink"
        src="@/images/icon/shrink.png"
        alt=""
        @click="isShrink = true"
      />
      <img
        v-else
        src="@/images/icon/shrink-left.png"
        alt=""
        @click="isShrink = false"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import crmNav from '@/components/layouts/crmNav';

export default {
  components: {
    crmNav,
  },
  data() {
    return {
      isQuickAddShow: false,
      isShrink: false,
    };
  },
  computed: {
    ...mapGetters({
      quickAuth: 'authority/quickAuth',
      authenticated: 'authority/authenticated',
    }),
  },
  mounted() {
    this.getAuthority({ menuUrl: '/quickAdd' })
  },
  methods: {
    ...mapActions({
      getAuthority: 'authority/getAuthority',
    }),

    handleAdd(type) {
      this.$emit('handleAdd', type);
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/const.less';

.crm-aside {
  max-width: 200px;
  height: 100%;
  .el-button {
    width: 120px;
    border: 1px solid #cfcfe5;
    background-color: @bg--plain;
    color: #cfcfe5;
    i {
      font-weight: @fw--bold;
    }
  }
  // 快速新增
  .quick-add-but {
    padding: 10px 40px;
    div {
      cursor: pointer;
    }
    .el-button {
      &:hover,
      &:focus {
        color: #cfcfe5;
        border-color: #cfcfe5;
        background-color: rgba(0, 0, 0, 0);
      }
    }
  }
  .shrink-add-but {
    width: 60px;
    padding: 20px 0 10px;
    text-align: center;
    .el-button {
      border: none;
      padding: 0;
      width: 32px;
      &:hover,
      &:focus {
        background-color: rgba(0, 0, 0, 0);
      }
    }
  }
  .shrink-ml {
    margin-left: -140px;
  }
  .quick-add-dialog {
    z-index: 11;
    position: absolute;
    top: 50px;
    left: 200px;
    ul {
      width: 156px;
      margin-left: 4px;
      color: @color--white;
      background-color: @bg--primary;
      box-shadow: @box-shadow;
      border-radius: 4px;
      padding: 10px 0;
      li {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        cursor: pointer;
        img {
          margin-right: 6px;
          width: 16px;
        }
        &:hover {
          background-color: @quick-add-hover;
        }
      }
    }
    // .arrow {
    //   position: absolute;
    //   top: 20px;
    //   border-width: 4px;
    //   border-style: solid;
    //   border-color: transparent @bg--primary transparent transparent;
    // }
  }

  // 收缩
  .collapse {
    // position: absolute;
    // bottom: 30px;
    height: 40px;
    margin-left: 20px;
    span {
      display: inline-block;
      width: 70px;
      height: 40px;
    }
    img {
      cursor: pointer;
      margin: 10px 0;
    }
  }
}
</style>
